import {
  Alert,
  Avatar,
  Box,
  Button,
  Divider,
  FormControlLabel,
  IconButton,
  MenuItem,
  Select,
  Snackbar,
  Switch,
  Tooltip,
  Typography,
  useMediaQuery,
  List,
  ListItem,
  ListItemButton,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  ListItemIcon,
  ListItemText,
  Paper,
  alpha
} from "@mui/material";
import React, { useEffect, useState } from "react";
import getInitials from "../../utils/getInitials";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentUser,
  selectCurrentUserProfile
} from "../../features/auth/authSelectors";
import {
  AppShortcut,
  Close,
  DarkMode,
  DeleteOutline,
  Info,
  LightMode,
  LinkOutlined,
  SupportAgent
} from "@mui/icons-material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { ReactComponent as TrophyIcon } from "../../assets/trophy.svg";
import { ReactComponent as StreaksIcon } from "../../assets/streak.svg";
import { ReactComponent as ChefIcon } from "../../assets/chef.svg";
import { ReactComponent as CoachIcon } from "../../assets/coach.svg";
import { ReactComponent as ConstantIcon } from "../../assets/constant.svg";
import { ReactComponent as BicepIcon } from "../../assets/bicep.svg";
import { ReactComponent as BananaIcon } from "../../assets/banana.svg";
import { ReactComponent as Lvl1Icon } from "../../assets/lvl1.svg";
import { ReactComponent as Lvl2Icon } from "../../assets/lvl2.svg";
import { ReactComponent as Lvl3Icon } from "../../assets/lvl3.svg";
import { ReactComponent as UserIcon } from "../../assets/profile.svg";
import { ReactComponent as LockIcon } from "../../assets/lock.svg";
import { ReactComponent as BillingIcon } from "../../assets/billing.svg";
import { ReactComponent as GroupIcon } from "../../assets/user.svg";
import { ReactComponent as StarIcon } from "../../assets/star.svg";
import { ReactComponent as LogoutIcon } from "../../assets/power.svg";
import { ReactComponent as PremiumIcon } from "../../assets/premiumicon.svg";
import {
  fetchCurrentUser,
  fetchCurrentUserProfileData,
  logoutUser,
  markAsRead,
  markReadNotification
} from "../../features/auth/authSlice";
import { useTheme } from "@emotion/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useSignedUrl from "../../utils/useSignedUrl";
import { toggleTheme } from "../../features/theme/themeSlice";
import useThemeColor from "../../utils/useTheme";
import { selectCurrentTheme } from "../../features/theme/themeSelectors";
import styled from "@emotion/styled";
import { deleteUser, editChallengeHandler } from "../../api/userApi";
import DeleteUserModal from "../Modals/DeleteUserModal";
import SubscriptionModal from "../Modals/SubscriptionModal";
import dayjs from "dayjs";
import AchievementModal from "../Modals/InfoModal";
import formatNumber from "../../utils/formatNumber";
import ReferralModal from "../Modals/ReferFriendModal";
import useIsMobile from "../Extra/useMobile";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  completePreviousDiaryPoints,
  getActiveChallenge
} from "../../features/diary/diarySlice";
import Fade from "@mui/material/Fade";
import { selectActiveChallenge } from "../../features/diary/diarySelectors";
import CouponModal from "../Modals/CouponModal";
import utc from "dayjs/plugin/utc";
import CustomerSupport from "../Extra/CustomerSupport";
dayjs.extend(utc);

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#aab4be",
        ...theme.applyStyles("dark", {
          backgroundColor: "#8796A5"
        })
      }
    }
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#001e3c",
    width: 32,
    height: 32,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`
    },
    ...theme.applyStyles("dark", {
      backgroundColor: "#003892"
    })
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#aab4be",
    borderRadius: 20 / 2,
    ...theme.applyStyles("dark", {
      backgroundColor: "#8796A5"
    })
  }
}));

// Custom styled switch
const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 52,
  height: 28,
  padding: 4,
  paddingRight: 10,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(4px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(20px)",
      "& .MuiSwitch-thumb": {
        backgroundColor: "#1976d2",
        // Add a pulse animation on toggle
        animation: "pulse 0.6s",
        "@keyframes pulse": {
          "0%": { boxShadow: "0 0 0 0 rgba(46, 202, 69, 0.7)" },
          "50%": { boxShadow: "0 0 0 6px rgba(46, 202, 69, 0)" },
          "100%": { boxShadow: "0 0 0 0 rgba(46, 202, 69, 0)" }
        }
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#bbdefb",
        backgroundImage: "linear-gradient(to right, #bbdefb, #90CAF9)"
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5
      }
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff"
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100] // kept this since it's unrelated to mode
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7
    }
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#bbb",
    width: 24,
    height: 24,
    borderRadius: "50%",
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 30%)",
    transition: theme.transitions.create(
      ["width", "transform", "background-color"],
      {
        duration: 200
      }
    ),
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      opacity: 0,
      transform: "scale(0)",
      transition: "transform 0.2s ease-in-out, opacity 0.2s ease-in-out"
    }
  },
  "& .MuiSwitch-track": {
    borderRadius: 14,
    opacity: 1,
    backgroundColor: "#919191",
    boxSizing: "border-box",
    backgroundImage: "linear-gradient(rgba(0,0,0,.05), rgba(0,0,0,0))",
    transition: theme.transitions.create(["background-color"], {
      duration: 500
    })
  },
  "& .Mui-checked .MuiSwitch-thumb:before": {
    opacity: 1,
    transform: "scale(0.6)"
  },
  "&:hover": {
    "& .MuiSwitch-thumb": {
      boxShadow: "0 0 1px 4px rgba(25, 118, 210, 0.15)"
    }
  }
}));

// Component with animation
const AnimatedSwitch = ({ isIncluded, onChange }) => {
  return (
    <Fade in={true} timeout={800}>
      <div>
        <StyledSwitch
          size="small"
          checked={isIncluded}
          onChange={async (e) => {
            try {
              await onChange(e);
            } catch (error) {
              console.error("Error updating switch status:", error);
            }
          }}
        />
      </div>
    </Fade>
  );
};

const ChallengeList = ({
  userProfileData,
  isMobile,
  currentTheme,
  selectedChallengeId,
  setSelectedChallengeId
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const styles = useThemeColor();
  const lastDiaryVisitedLevel = localStorage.getItem("lastDiaryVisitedLevel");

  // Function to get the appropriate icon based on level
  const getLevelIcon = (levelName) => {
    switch (levelName) {
      case "level1":
        return <EmojiEventsIcon sx={{ color: "#CD7F32" }} />;
      case "level2":
        return <MilitaryTechIcon sx={{ color: "#C0C0C0" }} />;
      case "level3":
        return <WorkspacePremiumIcon sx={{ color: "#FFD700" }} />;
      default:
        return <EmojiEventsIcon sx={{ color: "#FFD700" }} />;
    }
  };

  // Function to determine challenge status
  const getChallengeStatus = (startDate, endDate) => {
    const now = dayjs();
    const start = dayjs(startDate);
    const end = dayjs(endDate);

    if (now.isBefore(start)) return { label: "Upcoming", color: "#03a9f4" };
    if (now.isAfter(end)) return { label: "Completed", color: "#4caf50" };
    return { label: "Active", color: "#ff9800" };
  };

  return (
    <Paper
      elevation={3}
      sx={{
        bgcolor: styles.lightGreyColor,
        borderRadius: 2,
        maxHeight: 300,
        overflow: "auto",
        "&::-webkit-scrollbar": {
          width: "6px"
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#555",
          borderRadius: "6px"
        },
        border: `1px solid ${styles.lightGreyColor}`
      }}
    >
      <List disablePadding sx={{ py: 0 }}>
        {userProfileData?.challenges?.map((challenge, index) => {
          const status = getChallengeStatus(
            challenge.start_date,
            challenge.end_date
          );

          // Check if this user is included in this specific challenge
          const isIncluded = !challenge?.excluded_users?.includes(
            userProfileData?.userId
          );

          return (
            <Box
              key={challenge._id}
              sx={{
                ...(isMobile && {
                  width: "100% !important",
                  "::-webkit-scrollbar": {
                    display: "none"
                  }
                })
              }}
            >
              <ListItem
                sx={{
                  display: "block",
                  py: 1,
                  px: 2,
                  cursor: "pointer",
                  bgcolor:
                    selectedChallengeId === challenge._id
                      ? alpha("#1976d2", 0.35)
                      : "transparent",
                  "&:hover": {
                    bgcolor: alpha("#1976d2", 0.08)
                  },
                  transition: "background-color 0.2s"
                }}
                onClick={() => setSelectedChallengeId(challenge._id)}
              >
                {/* Mobile layout differs from desktop */}
                {isMobile ? (
                  <>
                    {/* Top section with icon and title */}
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <ListItemIcon sx={{ minWidth: 30 }}>
                        <Tooltip title={challenge?.diaryLevelName}>
                          {getLevelIcon(challenge.levelName)}
                        </Tooltip>
                      </ListItemIcon>
                      <Typography
                        variant="body2"
                        sx={{
                          color: styles.color,
                          fontWeight: 600,
                          textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                          flex: 1
                        }}
                      >
                        {challenge.title}
                      </Typography>
                    </Box>

                    {/* Date range */}
                    <Typography
                      variant="caption"
                      sx={{
                        color: styles.color,
                        letterSpacing: 0.2,
                        display: "block",
                        mb: 1
                      }}
                    >
                      {dayjs.utc(challenge.start_date).format("MMM DD")} -{" "}
                      {dayjs.utc(challenge.end_date).format("MMM DD, YYYY")}
                    </Typography>

                    {/* Status chip - centered */}
                    <Box
                      sx={{ display: "flex", justifyContent: "center", mb: 1 }}
                    >
                      <Chip
                        label={status.label}
                        size="small"
                        sx={{
                          backgroundColor: alpha(status.color, 0.2),
                          color: status.color,
                          fontWeight: 500,
                          fontSize: "0.7rem",
                          height: 22
                        }}
                      />
                    </Box>
                  </>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                      alignItems: "center",
                      gap: 5
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <ListItemIcon sx={{ minWidth: "auto" }}>
                        <Tooltip title={challenge?.diaryLevelName}>
                          {getLevelIcon(challenge.levelName)}
                        </Tooltip>
                      </ListItemIcon>
                      <Typography
                        variant="body2"
                        sx={{
                          color: styles.color,
                          fontWeight: 600,
                          textShadow: "0px 1px 2px rgba(0,0,0,0.3)"
                        }}
                      >
                        {challenge.title}
                      </Typography>
                    </Box>
                    <Typography
                      variant="caption"
                      fontWeight={600}
                      sx={{
                        color: styles.disabledColor,
                        letterSpacing: 0.2
                      }}
                    >
                      {dayjs.utc(challenge.start_date).format("MMM DD")} -{" "}
                      {dayjs.utc(challenge.end_date).format("MMM DD, YYYY")}
                    </Typography>
                    <Chip
                      label={status.label}
                      size="small"
                      sx={{
                        backgroundColor: alpha(status.color, 0.2),
                        color: status.color,
                        fontWeight: 500,
                        fontSize: "0.7rem",
                        height: 22
                      }}
                    />
                  </Box>
                )}

                {/* Individual controls for each challenge */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mt: 1
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      fontSize="12px"
                      color={isIncluded ? styles.color : "rgba(129, 129, 129)"}
                      fontWeight={600}
                      mr={1}
                    >
                      {isIncluded ? "Opt in" : "Opted out"}
                    </Typography>
                    <AnimatedSwitch
                      isIncluded={isIncluded}
                      onChange={async (e) => {
                        try {
                          await editChallengeHandler({
                            userId: userProfileData?.userId,
                            id: challenge._id
                          });
                          dispatch(
                            fetchCurrentUserProfileData({
                              diaryLevel:
                                JSON.parse(lastDiaryVisitedLevel || "{}")
                                  ?.level || "",
                              date: dayjs().format("YYYY-MM-DD")
                            })
                          );
                        } catch (error) {
                          console.error(
                            "Error updating user exclusion status:",
                            error
                          );
                        }
                      }}
                    />
                  </Box>

                  {isIncluded && status.label !== "Upcoming" && (
                    <Button
                      size="small"
                      sx={{
                        textTransform: "none",
                        background: "#368AD0",
                        color: "#fcfcfc",
                        fontSize: "0.7rem",
                        padding: "2px 8px",
                        borderRadius: "4px"
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        localStorage.removeItem("redirectToMod");
                        localStorage.setItem(
                          "diaryLastVisited",
                          dayjs().format("YYYY-MM-DD")
                        );
                        navigate(`/diary?leaderboard=${challenge._id}`);
                      }}
                    >
                      Leaderboard
                    </Button>
                  )}
                </Box>
              </ListItem>
              {index < userProfileData.challenges.length - 1 && (
                <Divider sx={{ backgroundColor: "#333" }} />
              )}
            </Box>
          );
        })}
      </List>
    </Paper>
  );
};

const getLeaderPosition = (index) => {
  switch (index) {
    case 0:
      return "1st 🥇";
    case 1:
      return "2nd 🥈";
    case 2:
      return "3rd 🥉";
    default:
      return `${index + 1}`;
  }
};

function Profile({
  openSubscriptionModal,
  setOpenSubscriptionModal,
  setOpenFreeTrialModal
}) {
  const userData = useSelector(selectCurrentUser);
  const userProfileData = useSelector(selectCurrentUserProfile);
  const currentTheme = useSelector(selectCurrentTheme);
  const [couponModal, setCouponModal] = useState(false);
  const dispatch = useDispatch();
  const styles = useThemeColor();
  const theme = useTheme(); // Use theme hook to get the theme
  const isInMobile = useIsMobile();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")) || isInMobile; // Correctly access breakpoints
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [deleteUserModal, setDeleteUserModal] = useState(false);
  const [openReferModal, setOpenReferModal] = useState(false);
  const [openSupportModal, setOpenSupportModal] = useState(false);
  const [openAppInstructionModal, setOpenAppInstructionModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [included, setIncluded] = useState(false);
  const [selectedChallengeId, setSelectedChallengeId] = useState(
    userProfileData?.challenges?.[0]?._id || null
  );
  const activeChallenge = useSelector(selectActiveChallenge);
  useEffect(() => {
    dispatch(
      getActiveChallenge({
        date: dayjs().format("YYYY-MM-DD"),
        getAllChallenges: true
      })
    );
    dispatch(markReadNotification());
    dispatch(markAsRead());
  }, []);
  // Find the currently selected challenge
  const currentChallenge =
    userProfileData?.challenges?.find(
      (challenge) => challenge._id === selectedChallengeId
    ) || userProfileData?.challenges?.[0];
  // useEffect(() => {
  //   dispatch(
  //     completePreviousDiaryPoints({
  //       // levelId: currentLevel?.levelId,
  //       currentDate: dayjs().format("YYYY-MM-DD")
  //     })
  //   );
  // }, [dispatch]);

  // Update the useEffect for challenge inclusion
  useEffect(() => {
    if (currentChallenge?._id) {
      setIncluded(
        currentChallenge?.challengeType === "Future"
          ? false
          : !currentChallenge?.excluded_users?.includes(userProfileData?.userId)
      );
    }
  }, [currentChallenge]);

  useEffect(() => {
    if (!selectedChallengeId)
      setSelectedChallengeId(userProfileData?.challenges?.[0]?._id);
  }, [userProfileData?.challenges]);
  const [searchParams] = useSearchParams();
  const oc = searchParams.get("oc");
  React.useEffect(() => {
    if (oc) {
      setOpenSupportModal(true);
    }
  }, [oc]);
  React.useEffect(() => {
    window.scrollTo(0, 0);
    const scrollableElement = document.getElementById("dashboard-main"); // or document.body
    scrollableElement.scrollTo(0, 0);
    localStorage.setItem("lastVisitedRoute", "/profile");
  }, []);
  const lastDiaryVisitedLevel = localStorage.getItem("lastDiaryVisitedLevel");
  useEffect(() => {
    dispatch(fetchCurrentUser(dayjs().format("YYYY-MM-DD")));
    dispatch(
      fetchCurrentUserProfileData({
        diaryLevel: JSON.parse(lastDiaryVisitedLevel || "{}")?.level || "",
        date: dayjs().format("YYYY-MM-DD")
      })
    );
  }, [dispatch]);

  // useEffect(() => {
  //   if (userProfileData?.challenge?._id) {
  //     setIncluded(
  //       !userProfileData?.challenge?.excluded_users?.includes(
  //         userProfileData?.userId
  //       )
  //     );
  //   }
  // }, [userProfileData?.challenge]);

  React.useEffect(() => {
    if (
      !userData.isFailedPayment &&
      !(
        userData?.isAdmin === 1 ||
        ["Coach", "Company"].includes(userData?.userType)
      ) &&
      !userData?.isSubscriptionActive &&
      (userData?.isTrainingFreeTrialExpired ||
        userData?.isDiaryFreeTrialExpired)
    ) {
      setOpenSubscriptionModal(true);
    }
  }, [userData]);
  const freeTrialExpired = dayjs().diff(dayjs(userData?.createdAt), "days");
  const imgSrc = useSignedUrl(
    userData?.profilePic,
    process.env.REACT_APP_BACKEND_PROFILE_IMAGE_LOCATION
  );
  const [badgeDialogOpen, setBadgeDialogOpen] = useState(false);
  const [selectedBadge, setSelectedBadge] = useState(null);

  // 3. Add this component before your Profile component (or after it)
  const BadgeDialog = ({ open, onClose, badge, styles }) => {
    if (!badge) return null;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: styles.lightGreyColor,
            color: styles.color,
            borderRadius: 2,
            margin: 2
          }
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            {badge.title}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close sx={{ color: styles.color }} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
          >
            <Box>{badge.icon}</Box>
            <Typography
              fontSize={14}
              textAlign="center"
              color={styles.lightBlack}
            >
              {badge.description}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  };

  const AppInstructionModal = ({ open, onClose, styles }) => {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: styles.lightGreyColor,
            color: styles.color,
            borderRadius: 2,
            margin: 2,
            maxHeight: "90vh"
          }
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            How Do I Make This an App?
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close sx={{ color: styles.color }} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Typography fontSize={14} color={styles.lightBlack}>
                This is a web app which works on desktop and mobile. This means
                it's not in the app store.
              </Typography>
              <Typography fontSize={14} color={styles.lightBlack}>
                To look like a "regular" app on your phone, create a bookmark to
                your home screen. You are looking for the "Add to Home Screen"
                option from your web browser.
              </Typography>
            </Box>

            <Box>
              <Typography
                fontSize={16}
                fontWeight={600}
                color={styles.color}
                mb={2}
              >
                Apple iOS How-To Example:
              </Typography>
              <Box
                component="img"
                src="https://threepillar-live.nyc3.digitaloceanspaces.com/training-pictures/AppleDemo1.png"
                alt="iOS Add to Home Screen Instructions"
                sx={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                }}
              />
            </Box>

            <Box>
              <Typography
                fontSize={16}
                fontWeight={600}
                color={styles.color}
                mb={2}
              >
                Android How-To Example:
              </Typography>
              <Box
                component="img"
                src="https://threepillar-live.nyc3.digitaloceanspaces.com/training-pictures/AndroidDemo.png"
                alt="Android Add to Home Screen Instructions"
                sx={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                }}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    );
  };
  const getBadgeData = (type, count, styles) => {
    const badgeMap = {
      chef: {
        title: "Chef",
        description:
          "Reflects the number of submitted Meal of the Days (MOD) posted publicly in the app.",
        icon: <ChefIcon height={60} width={60} />
      },
      secret: {
        title: "Secret",
        description:
          "Appears when at least 30 consecutive days of 800 grams or more are logged",
        icon: <BananaIcon height={60} width={60} />
      },
      level1: {
        title: "Level 1",
        description:
          "One hash mark each for the completion of #800gChallenge®, Lazy Macros®, and Three Pillars Method® programs.",
        icon: <Lvl1Icon height={60} width={60} />
      },
      level2: {
        title: "Level 2",
        description:
          "One hash mark each for the completion of #800gChallenge®, Lazy Macros®, and Three Pillars Method® programs.",
        icon: <Lvl2Icon height={60} width={60} />
      },
      level3: {
        title: "Level 3",
        description:
          "One hash mark each for the completion of #800gChallenge®, Lazy Macros®, and Three Pillars Method® programs.",
        icon: <Lvl3Icon height={60} width={60} />
      },
      coach: {
        title: "Coach",
        description:
          "Three Pillars Method® Coach. Fulfilled the requirements of the Coaches Masterclass and affiliation.",
        icon: <CoachIcon height={60} width={60} />
      },
      consistency: {
        title: "Consistency",
        description:
          "Appears when you've logged for at least 11 of the last 14 days.",
        icon: <BicepIcon height={60} width={60} />
      },
      streaking: {
        title: "Streaking",
        description:
          "Represents your greatest streak of diary logging days in a row.",
        icon: <ConstantIcon height={60} width={60} />
      }
    };

    return badgeMap[type];
  };
  const BadgeWrapper = ({ children, badgeData, isMobile, onClick }) => {
    if (isMobile) {
      return (
        <Box onClick={() => onClick(badgeData)} sx={{ cursor: "pointer" }}>
          {children}
        </Box>
      );
    }

    // Return the existing Tooltip for desktop
    return children;
  };

  return !(
    userData?.isAdmin === 1 || ["Coach", "Company"].includes(userData?.userType)
  ) &&
    !userData?.isSubscriptionActive &&
    (userData?.isTrainingFreeTrialExpired ||
      userData?.isDiaryFreeTrialExpired) &&
    !userData?.isFailedPayment ? (
    <></>
  ) : (
    <Box
      sx={{
        padding: { xs: "0 0 100px 0" }
      }}
    >
      <Box width="100%" component="img" src="/images/frame.jpg" alt="frame" />
      <Box p="0 24px" display="flex" flexDirection="column" gap={6}>
        <Box
          position="relative"
          sx={{
            display: {
              sm: "block",
              md: "flex"
            },
            gap: {
              sm: "140px",
              md: "200px"
            }
          }}
        >
          <Box
            display="flex"
            gap="10px"
            mt={isTablet ? 2.5 : 0}
            alignItems="center"
            onClick={() => navigate("/edit-profile")}
            sx={{
              transition: "transform 0.3s, box-shadow 0.3s",
              "&:hover": {
                cursor: "pointer",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                transform: "scale(1.05)"
              }
            }}
          >
            {userData?.profilePic ? (
              <Box
                component="img"
                height={170}
                borderRadius="50%"
                border={`3px solid ${styles.background}`}
                width={170}
                style={{
                  ...(isMobile && { top: "-45px" }),
                  "user-drag": "none",
                  "-webkit-user-drag": "none",
                  "-moz-user-select": "none"
                }}
                position={"absolute"}
                src={imgSrc}
                alt="avatar"
                bottom="-10px"
              />
            ) : (
              <Avatar
                sx={{
                  ...(isMobile && { top: "-45px" }),
                  width: 170,
                  height: 170,
                  position: "absolute",
                  bottom: "-10px",
                  border: `3px solid ${styles.background}`
                }}
              >
                <Typography
                  color={styles.color}
                  fontSize="30px"
                  fontWeight={400}
                >
                  {getInitials(userData?.displayName)}
                </Typography>
              </Avatar>
            )}{" "}
          </Box>
          <Box
            pl={isTablet ? 25 : 2}
            sx={{
              ...(isMobile && !isInMobile && { marginTop: "140px" })
            }}
          >
            <Typography color={styles.color} fontSize="30px" fontWeight={500}>
              {userData?.displayName}
            </Typography>
            {["Gym", "Company"]?.includes(userData?.userType) ? (
              <Typography color={styles.color} fontSize="16px" fontWeight={600}>
                {userData?.referenceName || userData?.displayName}
                {/* : userData?.displayName} */}
              </Typography>
            ) : (
              <></>
            )}
            <Typography
              color={styles.lightBlack}
              fontSize="16px"
              fontWeight={400}
            >
              {userData?.bio}
            </Typography>
            {userData?.url && (
              <Box
                display="flex"
                alignItems="center"
                gap="5px"
                sx={{
                  ":hover": {
                    cursor: "pointer"
                  }
                }}
                onClick={() => {
                  const fullUrl =
                    userData?.url.startsWith("http://") ||
                    userData?.url.startsWith("https://")
                      ? userData?.url
                      : `https://${userData?.url}`; // You can choose http or https based on your requirements

                  window.open(fullUrl, "_blank");
                }}
              >
                <LinkOutlined
                  color="#368AD0"
                  sx={{ path: { color: "#368AD0" } }}
                />
                <Typography color="#368AD0" fontSize="13px" fontWeight={500}>
                  {userData?.url}
                </Typography>
              </Box>
              // </a>
            )}
          </Box>
        </Box>
        {/* {userProfileData?.challenge?._id ||
        userProfileData?.approvedMealsCount ||
        userData?.completedLevel?.length ||
        userProfileData?.has30DayStreak800g ||
        (userData?.isAdmin && userData?.userType === "Coach") ||
        userProfileData?.isConsistent ||
        userProfileData?.maxStreak ? ( */}
        <Box
          padding={3}
          // height={isMobile ? 300 : 250}
          border="1px solid #8E8E8E"
          borderRadius={1}
          sx={{ background: styles.lightGreyColor }}
        >
          {userProfileData?.challenges?.length > 0 ? (
            <>
              {currentChallenge?._id ? (
                <Box
                  display="flex"
                  gap={3}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box
                    display="flex"
                    gap={2}
                    mb={2}
                    width={isMobile ? "100%" : "unset"}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <TrophyIcon />
                    <Box width={"100%"}>
                      <Box display="flex" gap={1} alignItems="center">
                        <Typography
                          sx={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(
                              `/point-stats?included=${included}&challenge=${currentChallenge?._id}`
                            )
                          }
                          color={styles.color}
                          fontSize={isMobile ? "16px" : "24px"}
                          fontWeight={500}
                        >
                          {included
                            ? formatNumber(
                                currentChallenge?.userChallengePoints
                              ) || 0
                            : 0}{" "}
                          pts
                        </Typography>
                      </Box>
                      <Typography
                        color={styles.lightBlack}
                        fontSize={isMobile ? "11px" : "14px"}
                        fontWeight={400}
                      >
                        Total points earned
                      </Typography>
                    </Box>
                  </Box>

                  {!isMobile && (
                    <Box display={"flex"} gap={8}>
                      <Box
                        display="flex"
                        gap={2}
                        width={isMobile ? "100%" : "unset"}
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box width={"100%"}>
                          <ChallengeList
                            userProfileData={userProfileData}
                            selectedChallengeId={selectedChallengeId}
                            setSelectedChallengeId={setSelectedChallengeId}
                            styles={styles}
                            currentTheme={currentTheme}
                            isMobile={isMobile}
                          />
                        </Box>
                      </Box>
                      {/* 
                      <Box
                        display="flex"
                        gap={2}
                        width={isMobile ? "100%" : "unset"}
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box width={"100%"} display="flex" alignItems="center">
                          <Typography
                            fontSize={isMobile ? "13px" : "16px"}
                            fontWeight={600}
                          >
                            Opt in{" "}
                          </Typography>
                          <Box display="flex" alignItems={"center"} gap="15px">
                            <Switch
                              checked={included}
                              onChange={async (e) => {
                                setIncluded(e.target.checked);
                                try {
                                  await editChallengeHandler({
                                    userId: userProfileData?.userId,
                                    id: currentChallenge?._id
                                  });
                                  dispatch(
                                    fetchCurrentUserProfileData({
                                      diaryLevel:
                                        JSON.parse(
                                          lastDiaryVisitedLevel || "{}"
                                        )?.level || "",
                                      date: dayjs().format("YYYY-MM-DD")
                                    })
                                  );
                                } catch (error) {
                                  console.error(
                                    "Error updating user exclusion status:",
                                    error
                                  );
                                }
                              }}
                            />
                            {included &&
                              currentChallenge?.challengeType !== "Future" && (
                                <Button
                                  sx={{
                                    textTransform: "none",
                                    background: "#368AD0",
                                    color: "#fcfcfc",
                                    height: isTablet ? "60px" : "40px",
                                    padding: "12px 24px",
                                    gap: "8px",
                                    borderRadius: "4px"
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/diary?leaderboard=${currentChallenge?._id}`
                                    )
                                  }
                                >
                                  Leaderboard
                                </Button>
                              )}
                          </Box>
                        </Box>
                      </Box> */}
                    </Box>
                  )}

                  <Box>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        navigate(
                          `/point-stats?included=${included}&challenge=${currentChallenge?._id}`
                        )
                      }
                      sx={{
                        textTransform: "none",
                        color: "#368AD0",
                        borderColor: "#368AD0",
                        gap: "8px",
                        borderRadius: "4px",
                        alignSelf: "flex-end"
                      }}
                    >
                      My Points
                    </Button>
                  </Box>
                </Box>
              ) : (
                <></>
              )}
            </>
          ) : activeChallenge?.length ? (
            <Box
              display="flex"
              gap={3}
              alignItems="center"
              justifyContent="space-between"
            >
              <Box></Box>
              <Button
                variant="outlined"
                onClick={() => navigate(`/point-stats`)}
                sx={{
                  textTransform: "none",
                  color: "#368AD0",
                  borderColor: "#368AD0",
                  gap: "8px",
                  borderRadius: "4px",
                  alignSelf: "flex-end"
                }}
              >
                My Points
              </Button>
            </Box>
          ) : (
            <></>
          )}
          {!isMobile ? (
            <></>
          ) : (
            userProfileData?.challenges?.length > 0 && (
              <Box
                display={"flex"}
                gap={2}
                flexDirection={isMobile ? "column" : "row"}
                my={2}
                justifyContent="space-between"
              >
                <Box
                  display="flex"
                  gap={2}
                  // width={isMobile ? "100%" : "unset"}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box
                    sx={{
                      width: "100% !important"
                    }}
                  >
                    <ChallengeList
                      userProfileData={userProfileData}
                      selectedChallengeId={selectedChallengeId}
                      setSelectedChallengeId={setSelectedChallengeId}
                      styles={styles}
                      isMobile={isMobile}
                    />
                    {/* <Typography
                      color={styles.lightBlack}
                      fontSize={isMobile ? "11px" : "14px"}
                      fontWeight={400}
                    >
                      Challenge is Live!
                    </Typography> */}
                  </Box>
                </Box>
                {/* <Box
                  display="flex"
                  gap={2}
                  width={isMobile ? "100%" : "unset"}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box width={"100%"}>
                    <Typography
                      // color={styles.lightBlack}
                      fontSize={isMobile ? "13px" : "16px"}
                      fontWeight={600}
                    >
                      Challenge Points
                    </Typography>
                    <Typography
                      textAlign={"center"}
                      color={styles.lightBlack}
                      fontSize={isMobile ? "11px" : "14px"}
                      fontWeight={400}
                    >
                      {userProfileData?.userChallengePoints}
                    </Typography>
                  </Box>
                </Box> */}
              </Box>
            )
          )}{" "}
          <>
            {" "}
            <Box>
              <Box display={"flex"} gap="10px">
                <Typography
                  color={styles.inputLabelColor}
                  fontSize="16px"
                  fontWeight={500}
                >
                  Badges{" "}
                </Typography>
                <IconButton
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  sx={{ padding: 0 }}
                >
                  <Info
                    sx={{
                      color: styles.color
                    }}
                  />
                </IconButton>
              </Box>
              {userProfileData?.approvedMealsCount ||
              userData?.completedLevel?.length ||
              userProfileData?.has30DayStreak800g ||
              (userData?.isAdmin && userData?.userType === "Coach") ||
              userProfileData?.isConsistent ||
              userProfileData?.maxStreak ? (
                // Replace your entire badges section (from the Box with overflowX: "auto" to the closing Box) with this:

                <Box
                  display="flex"
                  sx={{
                    overflowX: "auto",
                    overflowY: "hidden",
                    height: "70px",
                    "::-webkit-scrollbar": {
                      display: "none"
                    }
                  }}
                  mt={2}
                  gap={2}
                  alignItems="center"
                >
                  {/* Chef Badge */}
                  {userProfileData?.approvedMealsCount ? (
                    <BadgeWrapper
                      badgeData={getBadgeData("chef")}
                      isMobile={isMobile}
                      onClick={(badge) => {
                        setBadgeDialogOpen(true);
                        setSelectedBadge(badge);
                      }}
                    >
                      {isMobile ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap="10px"
                          position="relative"
                        >
                          <ChefIcon height={60} width={60} />
                          <Typography
                            color="#F6541C"
                            borderRadius="50%"
                            fontSize="smaller"
                            sx={{
                              padding:
                                String(userProfileData?.approvedMealsCount)
                                  ?.length === 1
                                  ? "0px 5px"
                                  : "1px 4px",
                              background: styles.color,
                              position: "absolute",
                              top: "30px",
                              right: "10px",
                              transform: "translate(50%, 50%)"
                            }}
                          >
                            {userProfileData?.approvedMealsCount}
                          </Typography>
                        </Box>
                      ) : (
                        <Tooltip
                          slotProps={{ tooltip: { sx: { padding: 0 } } }}
                          title={
                            <Box
                              sx={{
                                margin: 0,
                                padding: 2,
                                background: styles.color,
                                color: styles.background,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center",
                                transition: "transform 0.3s, box-shadow 0.3s",
                                "&:hover": {
                                  cursor: "pointer",
                                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                                  transform: "scale(1.05)"
                                }
                              }}
                            >
                              <Typography fontWeight="bold" fontSize={16}>
                                Chef
                              </Typography>
                              <Typography fontSize={13}>
                                Reflects the number of submitted Meal of the
                                Days (MOD) posted publicly in the app.
                              </Typography>
                            </Box>
                          }
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ cursor: "pointer" }}
                            gap="10px"
                            position="relative"
                          >
                            <ChefIcon height={60} width={60} />
                            <Typography
                              color="#F6541C"
                              borderRadius="50%"
                              fontSize="smaller"
                              sx={{
                                padding:
                                  String(userProfileData?.approvedMealsCount)
                                    ?.length === 1
                                    ? "0px 5px"
                                    : "1px 4px",
                                background: styles.color,
                                position: "absolute",
                                top: "30px",
                                right: "10px",
                                transform: "translate(50%, 50%)"
                              }}
                            >
                              {userProfileData?.approvedMealsCount}
                            </Typography>
                          </Box>
                        </Tooltip>
                      )}
                    </BadgeWrapper>
                  ) : null}

                  {/* Secret Badge */}
                  {+userProfileData?.max800gStreak >= 30 ? (
                    <BadgeWrapper
                      badgeData={getBadgeData("secret")}
                      isMobile={isMobile}
                      onClick={(badge) => {
                        setBadgeDialogOpen(true);
                        setSelectedBadge(badge);
                      }}
                    >
                      {isMobile ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap="10px"
                          position="relative"
                        >
                          <BananaIcon height={60} width={60} />
                        </Box>
                      ) : (
                        <Tooltip
                          slotProps={{ tooltip: { sx: { padding: 0 } } }}
                          title={
                            <Box
                              sx={{
                                margin: 0,
                                padding: 2,
                                background: styles.color,
                                color: styles.background,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <Typography fontWeight="bold" fontSize={16}>
                                Secret
                              </Typography>
                              <Typography fontSize={13}>
                                Appears when at least 30 consecutive days of 800
                                grams or more are logged
                              </Typography>
                            </Box>
                          }
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            gap="10px"
                            position="relative"
                          >
                            <BananaIcon height={60} width={60} />
                          </Box>
                        </Tooltip>
                      )}
                    </BadgeWrapper>
                  ) : null}

                  {/* Level 1 Badge */}
                  {userData?.completedLevel?.length === 1 ? (
                    <BadgeWrapper
                      badgeData={getBadgeData("level1")}
                      isMobile={isMobile}
                      onClick={(badge) => {
                        setBadgeDialogOpen(true);
                        setSelectedBadge(badge);
                      }}
                    >
                      {isMobile ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap="10px"
                          position="relative"
                        >
                          <Lvl1Icon height={60} width={60} />
                        </Box>
                      ) : (
                        <Tooltip
                          slotProps={{ tooltip: { sx: { padding: 0 } } }}
                          title={
                            <Box
                              sx={{
                                margin: 0,
                                padding: 2,
                                background: styles.color,
                                color: styles.background,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <Typography fontWeight="bold" fontSize={16}>
                                Level 1
                              </Typography>
                              <Typography fontSize={13}>
                                One hash mark each for the completion of
                                #800gChallenge®, Lazy Macros®, and Three Pillars
                                Method® programs.
                              </Typography>
                            </Box>
                          }
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            gap="10px"
                            position="relative"
                          >
                            <Lvl1Icon height={60} width={60} />
                          </Box>
                        </Tooltip>
                      )}
                    </BadgeWrapper>
                  ) : null}

                  {/* Level 2 Badge */}
                  {userData?.completedLevel?.length === 2 ? (
                    <BadgeWrapper
                      badgeData={getBadgeData("level2")}
                      isMobile={isMobile}
                      onClick={(badge) => {
                        setBadgeDialogOpen(true);
                        setSelectedBadge(badge);
                      }}
                    >
                      {isMobile ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap="10px"
                          position="relative"
                        >
                          <Lvl2Icon height={60} width={60} />
                        </Box>
                      ) : (
                        <Tooltip
                          slotProps={{ tooltip: { sx: { padding: 0 } } }}
                          title={
                            <Box
                              sx={{
                                margin: 0,
                                padding: 2,
                                background: styles.color,
                                color: styles.background,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <Typography fontWeight="bold" fontSize={16}>
                                Level 2
                              </Typography>
                              <Typography fontSize={13}>
                                One hash mark each for the completion of
                                #800gChallenge®, Lazy Macros®, and Three Pillars
                                Method® programs.
                              </Typography>
                            </Box>
                          }
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ cursor: "pointer" }}
                            gap="10px"
                            position="relative"
                          >
                            <Lvl2Icon height={60} width={60} />
                          </Box>
                        </Tooltip>
                      )}
                    </BadgeWrapper>
                  ) : null}

                  {/* Level 3 Badge */}
                  {userData?.completedLevel?.length === 3 ? (
                    <BadgeWrapper
                      badgeData={getBadgeData("level3")}
                      isMobile={isMobile}
                      onClick={(badge) => {
                        setBadgeDialogOpen(true);
                        setSelectedBadge(badge);
                      }}
                    >
                      {isMobile ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap="10px"
                          position="relative"
                        >
                          <Lvl3Icon height={60} width={60} />
                        </Box>
                      ) : (
                        <Tooltip
                          slotProps={{ tooltip: { sx: { padding: 0 } } }}
                          title={
                            <Box
                              sx={{
                                margin: 0,
                                padding: 2,
                                background: styles.color,
                                color: styles.background,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <Typography fontWeight="bold" fontSize={16}>
                                Level 3
                              </Typography>
                              <Typography fontSize={13}>
                                One hash mark each for the completion of
                                #800gChallenge®, Lazy Macros®, and Three Pillars
                                Method® programs.
                              </Typography>
                            </Box>
                          }
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ cursor: "pointer" }}
                            gap="10px"
                            position="relative"
                          >
                            <Lvl3Icon height={60} width={60} />
                          </Box>
                        </Tooltip>
                      )}
                    </BadgeWrapper>
                  ) : null}

                  {/* Coach Badge */}
                  {userData?.isAdmin && userData?.userType === "Coach" ? (
                    <BadgeWrapper
                      badgeData={getBadgeData("coach")}
                      isMobile={isMobile}
                      onClick={(badge) => {
                        setBadgeDialogOpen(true);
                        setSelectedBadge(badge);
                      }}
                    >
                      {isMobile ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap="10px"
                          position="relative"
                        >
                          <CoachIcon height={60} width={60} />
                        </Box>
                      ) : (
                        <Tooltip
                          slotProps={{ tooltip: { sx: { padding: 0 } } }}
                          title={
                            <Box
                              sx={{
                                margin: 0,
                                padding: 2,
                                background: styles.color,
                                color: styles.background,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <Typography fontWeight="bold" fontSize={16}>
                                Coach
                              </Typography>
                              <Typography fontSize={13}>
                                Three Pillars Method® Coach. Fulfilled the
                                requirements of the Coaches Masterclass and
                                affiliation.
                              </Typography>
                            </Box>
                          }
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            sx={{ cursor: "pointer" }}
                            justifyContent="center"
                            gap="10px"
                            position="relative"
                          >
                            <CoachIcon height={60} width={60} />
                          </Box>
                        </Tooltip>
                      )}
                    </BadgeWrapper>
                  ) : null}

                  {/* Consistency Badge */}
                  {userProfileData?.isConsistent ? (
                    <BadgeWrapper
                      badgeData={getBadgeData("consistency")}
                      isMobile={isMobile}
                      onClick={(badge) => {
                        setBadgeDialogOpen(true);
                        setSelectedBadge(badge);
                      }}
                    >
                      {isMobile ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap="10px"
                          position="relative"
                        >
                          <BicepIcon height={60} width={60} />
                        </Box>
                      ) : (
                        <Tooltip
                          slotProps={{ tooltip: { sx: { padding: 0 } } }}
                          title={
                            <Box
                              sx={{
                                margin: 0,
                                padding: 2,
                                background: styles.color,
                                color: styles.background,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <Typography fontWeight="bold" fontSize={16}>
                                Consistency
                              </Typography>
                              <Typography fontSize={13}>
                                Appears when you've logged for at least 11 of
                                the last 14 days.
                              </Typography>
                            </Box>
                          }
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            sx={{ cursor: "pointer" }}
                            alignItems="center"
                            justifyContent="center"
                            gap="10px"
                            position="relative"
                          >
                            <BicepIcon height={60} width={60} />
                          </Box>
                        </Tooltip>
                      )}
                    </BadgeWrapper>
                  ) : null}

                  {/* Streaking Badge */}
                  {userProfileData?.maxStreak ? (
                    <BadgeWrapper
                      badgeData={getBadgeData("streaking")}
                      isMobile={isMobile}
                      onClick={(badge) => {
                        setBadgeDialogOpen(true);
                        setSelectedBadge(badge);
                      }}
                    >
                      {isMobile ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap="10px"
                          position="relative"
                        >
                          <ConstantIcon height={60} width={60} />
                          <Typography
                            color="#F6541C"
                            borderRadius="50%"
                            fontSize="smaller"
                            sx={{
                              background: styles.color,
                              padding:
                                String(userProfileData?.maxStreak)?.length === 1
                                  ? "0px 5px"
                                  : "0px 3px",
                              position: "absolute",
                              top: "30px",
                              right: "10px",
                              transform: "translate(50%, 50%)"
                            }}
                          >
                            {userProfileData?.maxStreak}
                          </Typography>
                        </Box>
                      ) : (
                        <Tooltip
                          slotProps={{ tooltip: { sx: { padding: 0 } } }}
                          title={
                            <Box
                              sx={{
                                margin: 0,
                                padding: 2,
                                background: styles.color,
                                color: styles.background,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <Typography fontWeight="bold" fontSize={16}>
                                Streaking
                              </Typography>
                              <Typography fontSize={13}>
                                Represents your greatest streak of diary logging
                                days in a row.
                              </Typography>
                            </Box>
                          }
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            sx={{ cursor: "pointer" }}
                            alignItems="center"
                            justifyContent="center"
                            gap="10px"
                            position="relative"
                          >
                            <ConstantIcon height={60} width={60} />
                            <Typography
                              color="#F6541C"
                              borderRadius="50%"
                              fontSize="smaller"
                              sx={{
                                background: styles.color,
                                padding:
                                  String(userProfileData?.maxStreak)?.length ===
                                  1
                                    ? "0px 5px"
                                    : "0px 3px",
                                position: "absolute",
                                top: "30px",
                                right: "10px",
                                transform: "translate(50%, 50%)"
                              }}
                            >
                              {userProfileData?.maxStreak}
                            </Typography>
                          </Box>
                        </Tooltip>
                      )}
                    </BadgeWrapper>
                  ) : null}
                </Box>
              ) : (
                <></>
              )}
            </Box>
          </>
        </Box>
        {/* ) : (
          <></>
        )} */}
        <AchievementModal
          isMobile={isMobile}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
        {isMobile ? (
          userData.userType === "Affiliate" && userData.isSuperAdmin ? (
            <></>
          ) : !userData?.isSubscriptionActive ? (
            <Box
              display="flex"
              borderRadius="12px"
              padding={"42px 24px"}
              alignItems={"center"}
              gap="70px"
              sx={{
                background:
                  "linear-gradient(123.32deg, #368AD0 1.35%, #1A3A6D 83.05%)"
              }}
              onClick={() => setOpenSubscriptionModal(true)}
            >
              <Box>
                <Typography
                  color="#368AD0"
                  sx={{
                    background: "#FCFCFC",
                    width: "58px",
                    fontSize: "10px",
                    padding: "0 7px",
                    borderRadius: "100px",
                    height: "16px",
                    border: "1px solid #368AD0"
                  }}
                  mb={2}
                  fontWeight={500}
                >
                  Level Up
                </Typography>
                <Typography color="#FCFCFC" fontWeight={600} fontSize={"16px"}>
                  Get Full Access
                </Typography>
                <Button
                  sx={{
                    padding: "10px 10px 10px 0",
                    textTransform: "none",
                    fontWeight: "bold",
                    fontSize: "12px"
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenFreeTrialModal(true);
                  }}
                  variant="none"
                >
                  Free Trial (
                  {freeTrialExpired >= 5
                    ? "Expired"
                    : 5 - freeTrialExpired === 1
                      ? "Last Day"
                      : `${5 - freeTrialExpired} days left`}
                  )
                </Button>
              </Box>
              {/* <PremiumIcon /> */}
              <SubscriptionModal
                open={openSubscriptionModal}
                onClose={() => setOpenSubscriptionModal(false)}
                isMobile={true}
              />
            </Box>
          ) : (
            // userData?.userType === "Coach" && !userData?.isAdmin ? (
            //   <Box
            //     display="flex"
            //     borderRadius="12px"
            //     textAlign={"center"}
            //     padding={"12px"}
            //     alignItems={"center"}
            //     gap="70px"
            //     sx={{
            //       textTransform: "none",
            //       textAlign: "center",
            //       fontWeight: "bold",
            //       fontSize: "13.5px",
            //       background:
            //         "linear-gradient(123.32deg, #368AD0 1.35%, #1A3A6D 83.05%)"
            //     }}
            //     onClick={() => setCouponModal(true)}
            //   >
            //     Apply Coupon for Program Purchases
            //   </Box>
            // ) :
            <></>
          )
        ) : (
          <></>
        )}
        <CouponModal open={couponModal} onClose={() => setCouponModal(false)} />
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          alignItems={"flex-start"}
        >
          <Button
            style={{
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              gap: 20,
              alignItems: "center"
            }}
            onClick={() => navigate("/edit-profile")}
          >
            <Box>
              <UserIcon
                height={24}
                width={24}
                style={{ display: "flex", alignItems: "center" }}
              />
            </Box>
            <Box>
              <Typography
                color={styles.lightBlack}
                fontSize="14px"
                fontWeight={400}
              >
                Edit Profile
              </Typography>
            </Box>
          </Button>
          <Button
            style={{
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              gap: 20,
              alignItems: "center"
            }}
            onClick={() =>
              navigate("/update-password", {
                state: { email: userData?.email }
              })
            }
          >
            <Box>
              <LockIcon
                height={24}
                width={24}
                style={{ display: "flex", alignItems: "center" }}
              />
            </Box>
            <Box>
              <Typography
                color={styles.lightBlack}
                fontSize="14px"
                fontWeight={400}
              >
                Edit Password
              </Typography>
            </Box>
          </Button>
          <Button
            style={{
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              gap: 20,
              alignItems: "center"
            }}
            onClick={() => navigate("/manage-billing")}
          >
            <Box>
              <BillingIcon
                height={24}
                width={24}
                style={{ display: "flex", alignItems: "center" }}
              />
            </Box>
            <Box>
              <Typography
                color={styles.lightBlack}
                fontSize="14px"
                fontWeight={400}
              >
                Manage Billing
              </Typography>
            </Box>
          </Button>
          <Button
            style={{
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              gap: 20,
              alignItems: "center"
            }}
            onClick={() => setOpenAppInstructionModal(true)}
          >
            <Box>
              <AppShortcut
                height={24}
                width={24}
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: styles.lightBlack
                }}
              />
            </Box>
            <Box>
              <Typography
                color={styles.lightBlack}
                fontSize="14px"
                fontWeight={400}
              >
                “How Do I Make This an App?”
              </Typography>
            </Box>
          </Button>
          {/* <Button
            style={{
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              gap: 20,
              alignItems: "center"
            }}
            onClick={() => setOpenReferModal(true)}
          >
            <Box>
              <GroupIcon
                height={24}
                width={24}
                style={{ display: "flex", alignItems: "center" }}
              />
            </Box>
            <Box>
              <Typography
                color={styles.lightBlack}
                fontSize="14px"
                fontWeight={400}
              >
                Refer a Friend
              </Typography>
            </Box>
          </Button> */}
          <Button
            style={{
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              gap: 20,
              alignItems: "center"
            }}
            onClick={() => setOpenSupportModal(true)}
          >
            <Box>
              <SupportAgent
                height={24}
                width={24}
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "rgb(156, 163, 175)"
                }}
              />
            </Box>
            <Box>
              <Typography
                color={styles.lightBlack}
                fontSize="14px"
                fontWeight={400}
              >
                Customer Support
              </Typography>
            </Box>
          </Button>
          <Button
            onClick={async () => dispatch(toggleTheme())}
            style={{
              textTransform: "none",
              width: "100%",
              justifyContent: "space-between",
              height: "36px",
              gap: 20,
              alignItems: "center"
            }}
          >
            <Box display="flex" gap={2.5}>
              <Box>
                {currentTheme === "dark" ? (
                  <DarkMode
                    height={24}
                    width={24}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fill: "#9CA3AF"
                    }}
                  />
                ) : (
                  <LightMode
                    height={24}
                    width={24}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fill: "#9CA3AF"
                    }}
                  />
                )}
              </Box>
              <Box>
                <Typography
                  color={styles.lightBlack}
                  fontSize="14px"
                  fontWeight={400}
                >
                  Dark mode
                </Typography>
              </Box>
            </Box>
            <FormControlLabel
              control={
                <>
                  <Typography color={styles.lightBlack}>
                    {currentTheme === "dark" ? "ON" : "OFF"}
                  </Typography>
                  <MaterialUISwitch
                    sx={{ m: 1 }}
                    checked={currentTheme === "dark"}
                  />
                </>
              }
            />
          </Button>
          {/* <Button
            style={{
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              gap: 20,
              alignItems: "center"
            }}
          >
            <Box>
              <StarIcon
                height={24}
                width={24}
                style={{ display: "flex", alignItems: "center" }}
              />
            </Box>
            <Box>
              <Typography
                color={styles.lightBlack}
                fontSize="14px"
                fontWeight={400}
              >
                Rate Us
              </Typography>
            </Box>
          </Button> */}
          <Button
            style={{
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              gap: 20,
              alignItems: "center"
            }}
            onClick={() => {
              setTimeout(() => dispatch(logoutUser()), 2000);
            }}
          >
            <Box>
              <LogoutIcon
                height={24}
                width={24}
                style={{ display: "flex", alignItems: "center" }}
              />
            </Box>
            <Box>
              <Typography
                color={styles.lightBlack}
                fontSize="14px"
                fontWeight={400}
              >
                Logout
              </Typography>
            </Box>
          </Button>
          <Button
            style={{
              justifyContent: "flex-start",
              width: "100%",
              textTransform: "none",
              gap: 20,
              textAlign: "center",
              alignItems: "center"
            }}
            onClick={() => setDeleteUserModal(true)}
          >
            <Box>
              <DeleteOutline
                style={{
                  ":hover": {
                    background: "#FF4000"
                  },
                  display: "flex",
                  height: 24,
                  width: 24,
                  color: "#FF4000" // Use color here to fill the icon
                }}
              />
            </Box>
            <Box>
              <Typography color="#FF4000" fontSize="14px" fontWeight={400}>
                Delete Account
              </Typography>
            </Box>
          </Button>
          <ReferralModal
            open={openReferModal}
            onClose={() => setOpenReferModal(false)}
          />
          <CustomerSupport
            open={openSupportModal}
            setOpen={setOpenSupportModal}
            setSnackbarMessage={setSnackbarMessage}
            setOpenSnackbar={setOpenSnackbar}
          />
          <DeleteUserModal
            open={deleteUserModal}
            handleDelete={async () => {
              await deleteUser(
                userData?.userId,
                userData?.referenceId && !userData?.isAdmin ? true : false
              );
              setSnackbarMessage("Account deleted");
              setOpenSnackbar(true);
              setTimeout(() => {
                dispatch(logoutUser());
                navigate("/");
              }, 1500);
            }}
            handleClose={() => setDeleteUserModal(false)}
          />
        </Box>
      </Box>
      <Snackbar
        open={openSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={"success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <BadgeDialog
        open={badgeDialogOpen}
        onClose={() => setBadgeDialogOpen(false)}
        badge={selectedBadge}
        styles={styles}
      />
      <AppInstructionModal
        open={openAppInstructionModal}
        onClose={() => setOpenAppInstructionModal(false)}
        styles={styles}
      />
    </Box>
  );
}

export default Profile;
